
(function pwdResetModuleDefinition() {

    'use strict';

    angular.module('PwdReset', ['Auth', 'Language', 'ui.router', 'Config', 'EqualsValidation', 'ErrorsExtend', 'ClickOnce', 'EqualsValidation'])
        .config([
            'configProvider', '$stateProvider',
            function pwdResetConfig(config, $stateProvider) {

                $stateProvider.state('pwd-reset', {
                    url: "/pwd-reset/?code",
                    templateUrl: config.resourceUrl('/views/pwd-reset/pwd-reset.html'),
                    controller: 'PwdResetController'
                });

                $stateProvider.state('pwd-first-time', {
                    url: "/pwd-first-time/?code",
                    templateUrl: config.resourceUrl('/views/pwd-reset/pwd-reset.html'),
                    controller: 'PwdResetController'
                });

            }
        ]);
})();